module.exports = __webpack_public_path__ + "static/media/care-home.dfb477dc.svg";